import redactSecrets from './helpers/redact-secrets';

const redact = redactSecrets('[REDACTED]', {
  keys: [
    'guid', // @FIXME - i don't think this is working
  ],
  values: [],
});

/**
 * Creates a wrapped logger
 *
 * @param {[string, Console['log']]} [loggerName, originalLogger]
 * @return {*}
 */
const createWrappedLogger = ([loggerName, originalLogger]) => {
  if (process.env.NODE_ENV === 'production') {
    // Disable debug in production
    if (loggerName === 'debug') {
      return [loggerName, () => {}];
    }
  }

  if (typeof method === 'function') {
    const consoleMethod = originalLogger.bind(console);
    const logger = (message, ...optionalParams) => (optionalParams.length >= 1 ? consoleMethod(message, ...optionalParams.map(arg => redact.map(arg))) : consoleMethod(message));
    return [loggerName, logger];
  }

  return [loggerName, originalLogger];
};

/**
 * This works just like console while redacting all incoming arguments.
 * Ensure you use specifers when logging.
 *
 * %s for Strings
 * %o for JSON
 *
 * @type Console
 */

// eslint-disable-next-line import/prefer-default-export
export const log = {
  ...Object.fromEntries(Object.entries(console).map(createWrappedLogger)),
};
